// extracted by mini-css-extract-plugin
module.exports = {"btnsWrap":"Register_btnsWrap_PA0DL"};